import { HamburgerMenuProps } from '../../types/Navigation/HamburgerMenuProps';
import { slide as Menu } from 'react-burger-menu';

export const HamburgerMenu = (props: HamburgerMenuProps) => {
  const { navObj } = props;

  if (navObj !== undefined && navObj !== null) {
    const navArray = Object.entries(navObj)
      .map(([key, value]) => {
        return { [key]: { ...value } };
      })
      .sort((a, b) => {
        return a[Object.keys(a)[0]].baseOrder - b[Object.keys(b)[0]].baseOrder;
      })
      .filter((navItem) => {
        const key = Object.keys(navItem)[0];
        const value = navItem[key];
        return value.completed && !value.disabled;
      });

    return (
      <Menu styles={styles}>
        {navArray.map((navItem) => {
          const key = Object.keys(navItem)[0];
          const value = navItem[key];
          return (
            <a key={key} id={key} href={value.path}>
              {value.displayName}
            </a>
          );
        })}
      </Menu>
    );
  }
  return null;
};

const styles = {
  bmBurgerButton: {
    position: 'fixed',
    width: '30px',
    height: '30px',
    left: '10px',
    top: '10px',
  },
  bmBurgerBars: {
    background: '#373a47',
  },
  bmBurgerBarsHover: {
    background: '#a90000',
  },
  bmCrossButton: {
    height: '24px',
    width: '24px',
  },
  bmCross: {
    background: '#bdc3c7',
  },
  bmMenuWrap: {
    position: 'fixed',
    height: '100%',
  },
  bmMenu: {
    background: '#373a47',
    fontSize: '1.15em',
  },
  bmMorphShape: {
    fill: '#373a47',
  },
  bmItemList: {
    color: '#f5f5f4',
    padding: '0.8em',
  },
  bmItem: {
    height: '40px',
    marginBottom: '5px',
    paddingLeft: '10px',
    display: 'block',
    color: '#f5f5f4',
  },
  bmOverlay: {
    background: 'rgba(0, 0, 0, 0.3)',
  },
};
